import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from "@angular/router";
import { AuthInterceptor } from '@core/interceptors/auth.interceptor';
import { SentryInterceptor } from '@core/interceptors/sentry.interceptor';
import { NgbDateCustomParserFormatter } from "@core/providers/ngb-custom-date-formatter";
import { HeaderComponent } from '@layout/components/header/header.component';
import 'ag-grid-enterprise';
import { NavMenuComponent } from '@layout/components/nav-menu/nav-menu.component';
import { NgbDateParserFormatter, NgbDropdownModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import * as Sentry from "@sentry/angular";
import { LoaderComponent } from "@shared/components/commons/loader/loader.component";
import { sentryErrorHandlerOptions } from "@shared/constants/sentry-error-handler-options";
import { AppCopyDirective } from '@shared/directives/copy.directive';
import { AppSpinnerDirective } from '@shared/directives/spinner.directive';
import { NgxMaskDirective, provideNgxMask } from "ngx-mask";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app.component';
import { AppPipesModule } from './app.pipes.module';
import { AppRoutingModule } from './app.routing.module';

@NgModule({
  declarations: [AppComponent],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SentryInterceptor, multi: true },
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler(sentryErrorHandlerOptions) },
    { provide: Sentry.TraceService, deps: [Router] },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    { provide: APP_INITIALIZER, useFactory: () => () => {}, deps: [Sentry.TraceService], multi: true },
    provideNgxMask()
  ],
  bootstrap: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,

    NgbDropdownModule,
    AppPipesModule,
    ToastrModule.forRoot(),
    NgxSkeletonLoaderModule,

    NgbTooltip,
    AppSpinnerDirective,
    AppCopyDirective,
    NgxMaskDirective,

    NavMenuComponent,
    HeaderComponent,
    LoaderComponent,
  ]
})
export class AppModule {}
